/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clear_Light_Whale_SingInputs */

const en_clear_light_whale_sing = /** @type {(inputs: Clear_Light_Whale_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://help.kultify.com/en/article/data-import-users-1y0q770/`)
};

const de_clear_light_whale_sing = /** @type {(inputs: Clear_Light_Whale_SingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://help.kultify.com/de/article/datenimport-benutzer-1y0q770/`)
};

/**
* | output |
* | --- |
* | "https://help.kultify.com/en/article/data-import-users-1y0q770/" |
*
* @param {Clear_Light_Whale_SingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const clear_light_whale_sing = /** @type {((inputs?: Clear_Light_Whale_SingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clear_Light_Whale_SingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clear_light_whale_sing(inputs)
	return de_clear_light_whale_sing(inputs)
});